export const APPLICATION_LIST_REQUEST = 'APPLICATION_LIST_REQUEST'
export const APPLICATION_LIST_SUCCESS = 'APPLICATION_LIST_SUCCESS'
export const APPLICATION_LIST_FAIL = 'APPLICATION_LIST_FAIL'
export const APPLICATION_LIST_RESET = 'APPLICATION_LIST_RESET'

export const INVOICE_APPLICATION_LIST_REQUEST = 'INVOICE_APPLICATION_LIST_REQUEST'
export const INVOICE_APPLICATION_LIST_SUCCESS = 'INVOICE_APPLICATION_LIST_SUCCESS'
export const INVOICE_APPLICATION_LIST_FAIL = 'INVOICE_APPLICATION_LIST_FAIL'
export const INVOICE_APPLICATION_LIST_RESET = 'INVOICE_APPLICATION_LIST_RESET'